/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'message-items';
const componentName = 'content-rewrite-rule';
const prefix = `${moduleName}.${componentName}`;

export const responseContentRewriteRuleBreadCrumbTitle = `${prefix}.responseContentRewriteRuleBreadCrumbTitle`;

export const ENGLISH = {
    [responseContentRewriteRuleBreadCrumbTitle]: 'Response Content Rewrite Rule',
};
